import type { Notification } from "@circle-react/types/Notification";
import { Link } from "@tanstack/react-router";

import { useReportFlaggedContentModal } from "@/react/components/SettingsApp/Moderation/ReportFlaggedContentModal";

import { DefaultNotificationContent } from "./DefaultNotificationContent";

export const ModerationNotification = ({
  notification,
  onClickHandler,
  isMarkedAsRead,
}: {
  notification: Notification;
  onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isMarkedAsRead: boolean;
}) => {
  const flaggedContentId = (() => {
    const queryString = notification.action_web_path?.split("?")[1];
    return queryString
      ? new URLSearchParams(queryString).get("flagged_content_id")
      : null;
  })();

  const modal = useReportFlaggedContentModal();

  return (
    <Link to={notification.action_web_path} className="w-full">
      <button
        type="button"
        onClick={event => {
          onClickHandler(event);
          if (event.metaKey || event.ctrlKey) {
            return;
          }
          event.preventDefault();
          if (flaggedContentId) {
            void modal.show({
              flaggedContentId,
              shouldShowGoToModerationButton: true,
            });
          }
        }}
        className="w-full text-left"
      >
        <DefaultNotificationContent
          notification={notification}
          isMarkedAsRead={isMarkedAsRead}
        />
      </button>
    </Link>
  );
};
